import applyBulkItemActionOperation from 'owa-service/lib/operation/applyBulkItemActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import applyBulkItemActionRequest from 'owa-service/lib/factory/applyBulkItemActionRequest';
/**
 * Apply bulk item action service
 * @param actionType the bulk action type
 * @param emailAddresses emailaddresses
 * @param sourceFolderId the source folderId
 * @param keepNType whether to keep last N items or use dateTime
 * @param keepNCount number of items to keep or date to keep items that are more recent
 * @param destinationFolderId the folder to move the items to
 * @param customData custom data to use in the bulk action manager
 * @return the ApplyBulkItemActionResponse
 */
export default function applyBulkItemActionService(actionType, emailAddresses, sourceFolderId, keepNType, keepNCount, destinationFolderId, customData) {
    var requestBody = applyBulkItemActionRequest({
        ActionType: 0 /* Move */,
        DestinationFolderId: { Id: destinationFolderId },
        EmailAddresses: emailAddresses,
        SourceFolderId: { Id: sourceFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
        BulkActionRequest: true,
        BulkActionCustomData: JSON.stringify(customData),
    });
    return applyBulkItemActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    });
}
//# sourceMappingURL=applyBulkItemActionService.js.map